<template>
  <ModalWrapper
    v-if="displayModal"
    isCollapsetoModal
    :ariaLabelledby="ariaLabelledby"
    id="modal-card-services"
    @on-close-modal="emit('closeModal')"
  >
    <template #header>
      <button type="button" class="btn-close" @click="emit('closeModal')">
        <i class="icon-cross-out" aria-hidden="true"></i>
        <span class="sr-only">Fermer</span>
      </button>
      <h1 class="modal-title" :id="ariaLabelledby">
        {{ modalTitle }}
      </h1>
    </template>
    <template #body>
      <ul class="services__list">
        <li v-for="(service, idx) in cardServicesTransformer.data" :key="`service-${ idx }`" class="services__item">
          <h4>{{ service.name }}</h4>
          <ul class="service-places__list">
            <li v-for="(place, jdx) in service.places" :key="`service-place-${ jdx }`">
              <div class="service__item-inner-wrapper">
                <h4>
                  <i class="icon-medico-social" aria-hidden="true"></i>
                  <a :href="place.url" class="">{{ place.name }}</a>
                </h4>
                <p v-if="place.types">
                  <i class="icon icon-cards_activites" aria-hidden="true"></i>
                  <span class="display-block">
                    <span v-for="(type, kdx) in place.types.slice(0, limitTypesDisplayed)" :key="`service-place-type${ kdx }`">
                      {{ type }}
                      <span v-if="kdx < place.types.length - 1 && kdx < limitTypesDisplayed - 1">|&nbsp;</span>
                      <span v-if="kdx === limitTypesDisplayed - 1 && nbPlacesAfterLimit(place.types.length) > 0">...+{{ nbPlacesAfterLimit(place.types.length) }}</span>
                    </span>
                  </span>
                </p>
                <p v-if="place.patientele">
                  <i class="icon icon-user-nc" aria-hidden="true"></i>
                  <span>{{ place.patientele }}</span>
                </p>
                <p v-if="place.phones?.length > 0" class="service__item--phones">
                  <i class="icon icon-cards-phone"></i>
                  <span v-for="(phone, kdx) in place.phones" :key="`service-place-phone${ kdx }`">
                    <a :href="`tel:${ phone }`">{{ phone }}</a>
                    <span v-if="kdx < place.phones.length - 1">&nbsp;|&nbsp;</span>
                  </span>
                </p>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </template>
  </ModalWrapper>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue';

import ModalWrapper from '@/components/sharedComponents/modals/ModalWrapper.component.vue';

const supportedKeyName = 'sm_os_macro_mode_prise_en_charge';
const undefinedSpecialityLabel = 'Non défini';

const props = defineProps({
  displayModal: {
    required: true,
    type: Boolean,
  },
  services: {
    required: true,
    type: Array,
  },
});

const emit = defineEmits('closeModal');

const cardServicesTransformer = computed(() => {
  let services = [];

  if (props.services) {
    services = props.services.reduce((servicesAcc, oneCardService) => {
      const placeToAdd = {
        name: oneCardService.tm_X3b_und_title[0],
        phones: oneCardService.tm_X3b_und_etb_telephones,
        types: oneCardService.tm_X3b_und_field_uo_type_name,
        url: oneCardService.os_lien,
      };
      const supportedValueName = oneCardService[supportedKeyName] ? oneCardService[supportedKeyName][0] : undefinedSpecialityLabel;
      let foundIndexService = servicesAcc.findIndex((x) => x.name === supportedValueName);
      let idxSorted = 0;
      let idxFound = false;

      if (foundIndexService < 0) {
        while (!idxFound && idxSorted < servicesAcc.length) {
          if (supportedValueName.localeCompare(servicesAcc[idxSorted].name) <= 0) {
            idxFound = true;
            break;
          }

          idxSorted += 1;
        }

        foundIndexService = idxSorted;

        servicesAcc.splice(foundIndexService, 0, {
          name: supportedValueName,
          places: [],
        });
      }

      idxSorted = 0;
      idxFound = false;

      while (!idxFound && idxSorted < servicesAcc[foundIndexService].places.length) {
        if (oneCardService.tm_X3b_und_title[0].localeCompare(servicesAcc[foundIndexService].places[idxSorted].name) <= 0) {
          idxFound = true;
          break;
        }

        idxSorted += 1;
      }

      if (oneCardService.tm_X3b_und_field_patientele?.length > 0) {
        placeToAdd.patientele = oneCardService.tm_X3b_und_field_patientele[0];
      }

      servicesAcc[foundIndexService].places.splice(idxSorted, 0, placeToAdd);

      return servicesAcc;
    }, []);
  }

  return {
    data: services,
    nbService: props.services.length,
  };
});

const ariaLabelledby = 'titlemodal-card-services';
const limitTypesDisplayed = 3;
const modalTitle = window.drupalSettings.services_popin.popin_title_label;

const nbPlacesAfterLimit = (nbPlaces) => nbPlaces - limitTypesDisplayed;
</script>
